import { Container } from '@material-ui/core';
import AddIcCallIcon from '@material-ui/icons/AddIcCall';
import EmailIcon from '@material-ui/icons/Email';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import React from 'react';
import TypeAnimation from 'react-type-animation';

const Header = () => {
    return (
        <div className="header_area">
            <Container maxWidth="lg">
                <div className="row align-items-center">
                    <div className="col-md header_about_me">
                        <TypeAnimation
                            cursor={true}
                            sequence={[
                                'Full MERN-Stack Web Developer',
                                1000,
                                'Munir Uddin Mahbub.',
                                500,
                                'Front End Developer.',
                                500,
                                'Back End Developer.',
                                500,
                                'React Native Developer.',
                                500,
                                'App Developer.',
                                500,
                            ]}
                            wrapper="h2"
                        />
                        {/* <Typical
                            steps={[
                                'Full MERN-Stack Web Developer',
                                1000,
                                'Munir Uddin Mahbub.',
                                500,
                                'Front End Developer.',
                                500,
                                'Back End Developer.',
                                500,
                                'React Native Developer.',
                                500,
                                'App Developer.',
                                500,
                            ]}
                            loop={Infinity}
                            wrapper="h2"
                        /> */}
                        <p>
                            Web Design & Development is my passion, I get deeper to understand
                            client&apos;s need & problems. My mission is to satisfy every client and
                            become myself a pro developer to learn new updates every day.
                            You&apos;ll get lifetime support in any situation, I Premise that,
                            You&apos;ll get Fanatical Support and Absolutely Positively On-time
                            Delivery.
                        </p>
                        <div>
                            <a  href="https://www.linkedin.com/in/mahbub-hasan1" target="_blank" rel="noopener noreferrer">
                                <LinkedInIcon className="icon" />
                            </a>
                            <a  href="https://github.com/Mahbub-Hasan2" target="_blank" rel="noopener noreferrer">
                                <GitHubIcon className="icon" />
                            </a>
                            <a href="mailto:mahbubdev1@gmail.com">
                                <EmailIcon className="icon" />
                            </a>
                            <a href="tel:+8801966945992">
                                <AddIcCallIcon className="icon" />
                            </a>
                        </div>
                    </div>
                    <div className="col-md text-center">
                        <img className="img-fluid" src="https://camo.githubusercontent.com/62da68eb62b1e5f175f7d1f0191dd89a653d7908feb22d37d4a0ab07365d6791/68747470733a2f2f6d656469612e67697068792e636f6d2f6d656469612f4d3967624264396e6244724f5475314d71782f67697068792e676966" alt="img" />
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default Header;
